import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const TrackRecord = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[6].title)} menuList={menuList[6].list} backgroundImage="/imgs/bg_trackrecord" />
      <div className="track_record_wrap" style={{ maxWidth: "1920px", width: "100%" }}>
        <Outlet />
      </div>
    </>
  );
};

export default TrackRecord;
